// Lead Status Configuration
export const LEAD_STATUSES = [
  { value: "new", label: "New" },
  { value: "contacted", label: "Contacted" },
  { value: "confirmed", label: "Confirmed" },
  { value: "qualified", label: "Qualified" },
  { value: "proposal", label: "Proposal" },
  { value: "negotiation", label: "Negotiation" },
  { value: "stopped_engaging", label: "Stopped Engaging" },
  { value: "closed_won", label: "Closed (Won)" },
  { value: "closed_lost", label: "Closed (Lost)" }
];

// Status options for filter dropdowns (includes an "All Statuses" option)
export const LEAD_STATUS_FILTER_OPTIONS = [
  { value: "", label: "All Statuses" }, // For LeadsFilters.js
  { value: "all", label: "All Statuses" }, // For FilterBar.js
  ...LEAD_STATUSES
];

// Status options for tables (includes a "Select" option)
export const LEAD_STATUS_TABLE_OPTIONS = [
  { value: "", label: "Select" },
  { value: "new", label: "New" },
  { value: "pending", label: "Pending" },
  { value: "contacted", label: "Contacted" },
  { value: "confirmed", label: "Confirmed" },
  { value: "qualified", label: "Qualified" },
  { value: "proposal", label: "Proposal" },
  { value: "negotiation", label: "Negotiation" },
  { value: "disqualified", label: "Disqualified" },
  { value: "stopped_engaging", label: "Stopped Engaging" },
  { value: "converted", label: "Converted" },
  { value: "closed_won", label: "Closed (Won)" },
  { value: "closed_lost", label: "Closed (Lost)" }
];

// Priority options
export const PRIORITY_OPTIONS = [
  { value: 4, label: "Critical" },
  { value: 3, label: "High" },
  { value: 2, label: "Medium" },
  { value: 1, label: "Low" },
  { value: 0, label: "None" }
];

// Priority options for filters (includes an "All Priorities" option)
export const PRIORITY_FILTER_OPTIONS = [
  { value: "", label: "All Priorities" }, // For LeadsFilters.js
  { value: "all", label: "All Priorities" }, // For FilterBar.js
  ...PRIORITY_OPTIONS.map(option => ({
    ...option,
    value: option.value.toString() // Convert to string for filter components
  }))
];

// Date formatting
export const DATE_FORMAT = 'MMM d, yyyy';
export const DATE_TIME_FORMAT = 'MMM d, yyyy h:mm a'; 